import { ComponentView } from 'src/app/models/enums';

export type CaptureStateModel = {
  currentComponentView: ComponentView;
};

export const captureStateModelDefault: CaptureStateModel = {
  currentComponentView: ComponentView.EMPTY_STATE_MESSAGE,
};
